export enum FinancialInquiryStatusOption {
  RETURN = '9d9ce627-016f-4fac-8bf0-ecb4c17f371c',
  COMPLETE = 'b8750013-62c3-45d4-833d-2c98270ea52c',
  UPDATED = '11dc9baa-a3f5-42b8-8127-6ae64e2f781a',
  REJECTED = 'e1b80ad6-ad80-479b-8651-1bb5cc8b5452',
  CANCELED = '1756e7a8-9ed3-4443-baf2-38f3d2bb8014',
}
